module.exports = __webpack_public_path__ + "img/client_icon.92cc0c89.svg";